import { SearchProvider } from './contexts';
import { SearchPage } from './SearchPageNew';

export const SearchPageWrapper = () => {
  return (
    <SearchProvider>
      <SearchPage />
    </SearchProvider>
  );
};
